export const BREADCRUMB_ROOT = "uniQui";